import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import { Link, withRouter } from 'react-router-dom'
//import hello from 'hellojs'

import auth from '~/services/auth'

import { TextLoader } from '~/components'

const Login = createReactClass({

	propTypes: {
		router: PropTypes.object,
		session: PropTypes.object,
		loginOnly: PropTypes.bool.isRequired
	},

	emailOpts: {},

	getInitialState: function() {
		return {
			formData: {},
			loading: false,
			//method: !!window.location.hash ? window.location.hash.substring(1) : 'social',
			method: 'email',
			loginOnly: this.props.loginOnly
		}
	},

	componentWillMount: function() {
		//hello.init(auth.hello.credentials);
	},

	componentDidMount: function() {
		var email = this.props.match.query && 'email' in this.props.match.query ? this.props.match.query.email : ''
		if( !email ) return;
		this.emailOpts.readOnly = 'readOnly'
		this.setState({
			formData: { email: email }
		})
	},

	loginSuccess: function(data) {
		this.props.loginOrCreateAccount(data.network, data.authResponse)
	},

	loginWithEmail: function(e) {

		e.preventDefault();

		let responseData = {
			email: this.refs.email.value,
			password: this.refs.pass.value,
			cpassword: !this.state.loginOnly ? this.refs.cpass.value : false
		}
		if( !this.state.loginOnly ) responseData.first_name = this.refs.first_name.value
		if( !this.state.loginOnly ) responseData.last_name = this.refs.last_name.value

		this.setState({
			formData: responseData
		})

		this.props.loginOrCreateAccount('email', responseData)

	},

	showError: function(data) {
		//console.log(data.error.message)
	},

	loginFacebook: function() {
		this.loginWithSocialMedia('facebook')
	},

	loginLinkedin: function() {
		this.loginWithSocialMedia('linkedin')
	},

	loginWithSocialMedia: function(client) {
		if( !client ) return false;
		let options = auth.hello[client];
		//hello(client).login(options).then(this.loginSuccess, this.showError)
	},

	rotateCard: function() {
		this.setState({
			method: this.state.method == 'social' ? 'email' : 'social'
		})
	},

	render: function() {

		return (
			<div className="slide-holder login-form">
				<img src="/img/5T9C-logo.png" className="mbot40 pleft25 pright25 img-responsive" alt=""/>
				<div id="login-slide" className={"slide-wrapper flipper" + (this.state.method !== 'social' ? ' hover' : '')}>
					<header className="bg-deep-main ptop20 pbot20">
						<h4 className="text-dark-gray text-center mtop0 mbot0">{ this.state.loginOnly ? 'Sign in' : 'Register' }</h4>
					</header>
					<div className="inner no-footer">
						<div className="">

							{ /* <div className="bg-light-main bg-slightly-transparent transparent front p20">
								{( this.props.session.fetching.user
									? <TextLoader classes="text-white ptop30 pbot30" />
									: <div>
										<p className="text-center login-buttons">
											<i className="fa fa-facebook-square text-pale-main login-button" onClick={this.loginFacebook}></i>
											<i className="fa fa-linkedin-square text-pale-main login-button mleft20" onClick={this.loginLinkedin}></i>
										</p>
										<div className="clearix"></div>
									</div>
								)}
							</div> */ }

							<div className="bg-light-main bg-slightly-transparent transparent back">
								<form onSubmit={this.loginWithEmail}>
									{( this.props.session.fetching.user
										? <TextLoader classes="text-white ptop30 pbot30" />
										: <div>
											<div className="register-email">

												{ !this.state.loginOnly &&
													<div className="input">
														<i className="icon-user" />
														<input type="text" name="first_name" ref="first_name" placeholder="First Name" className="form-control half" value={this.state.formData.first_name} />
														<input type="text" name="last_name" ref="last_name" placeholder="Last Name" className="form-control half" value={this.state.formData.last_name} />
														<div className="clearfix" />
													</div>
												}

												<div className="input">
													<i className="icon-envelope" />
													<input type="text" name="email" ref="email" placeholder="Email" className="form-control" value={this.state.formData.email} { ...this.emailOpts } />
													<div className="clearfix" />
												</div>

												<div className="input">
													<i className="icon-lock" />
													<input type="password" name="pass" ref="pass" placeholder="Password" className="form-control" />
													<div className="clearfix" />
												</div>

												{ !this.state.loginOnly
													? <div className="input">
														<i className="icon-rotation-lock" />
														<input type="password" name="cpass" ref="cpass" placeholder="Confirm Password" className="form-control" />
														<div className="clearfix" />
													</div>
													: <div className="input">
														<p className="small text-right text-dark-main"><Link to='/password-reset' className="no-style">Forgotten your password?</Link></p>
														<div className="clearfix" />
													</div>
												}

											</div>
											<div className="clearix" />
											<footer className="bg-deep-main text-center text-white">
												<button type="submit" className="p20 btn btn-none btn-block">Submit</button>
											</footer>
										</div>
									)}
								</form>
							</div>

						</div>
					</div>
				</div>
				<p className="mtop20 pleft10 pright10">
					{ /*
					!this.props.session.fetching.user &&
						<span>
							<a href="javascript:void(0);" onClick={this.rotateCard} className="text-dark-gray">
								{ this.state.method === 'social' ? "Don't have social media?" : "Use Facebook or LinkedIn" }
							</a>
						</span>
					*/ }
					{
					<span className="pull-right">
						{ this.state.loginOnly 
							? <Link to={"/register" + ('stripe_customer_id' in this.props ? '/'+this.props.stripe_customer_id : '') + "#" + this.state.method} className="text-blue">Register</Link>
							: <Link to={"/login#" + this.state.method} className="text-blue">Login</Link>
						}
					</span>
					}
				</p>
			</div>
		)
	}

})

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/LoginSlidePart.jsx